export default __webpack_public_path__ + "static/media/SRMUH-logo.86ae38b6.jpg";